"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onMount: function () {
        setTimeout(() => this.emit('dismiss'), 15000);
    },
    onYes: function () {
        this.input.actions.yes && typeof this.input.actions.yes == 'function' && this.input.actions.yes();
        this.input.actions.yes && typeof this.input.actions.yes.fn == 'function' && this.input.actions.yes.fn();
        this.emit('yes');
        this.emit('dismiss');
    },
    onNo: function () {
        this.input.actions.no && this.input.actions.no.fn && this.input.actions.no.fn();
        this.emit('no');
        this.emit('dismiss');
    },
    onPassive: function ({gstate, navigate}) {
        try {
            gstate && GState[gstate.target][gstate.call](...gstate.arguments || []);
            navigate && window.navigate(navigate.pathname);
        } catch (error) {
            console.log('Invalid Passive Dialog Action Parameters: ', error);
        }
    },
    onDismiss: function () {
        this.emit('dismiss');
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/DialogModal/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Bx_template = require("../Bx/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Bx_tag = marko_loadTag(Bx_template),
    Locale_template = require("../Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Row_template = require("../Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    WSAdapt_template = require("../WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_attrs0 = {
        "class": "dialog-modal position-absolute zindex-4 h-100 top-0 left-0 right-0 d-flex align-items-center center"
      },
    marko_attrs1 = {
        "class": "position-absolute top-0 w-100 h-100 theme-bg-transparent animated fadeIn faster"
      },
    marko_attrs2 = {
        "class": "card shadow-lg"
      },
    marko_attrs3 = {
        "class": "card-content"
      },
    marko_attrs4 = {
        "class": "px-2 py-1"
      },
    marko_attrs5 = {
        "class": "position-absolute zindex-1 right-0 top-0 m-1 cursor-pointer"
      },
    marko_attrs6 = {
        "class": "text-primary mt-0"
      },
    marko_attrs7 = {
        "class": "d-inline-block mb-2 text-primary cursor-pointer"
      },
    marko_attrs8 = {
        "class": "buttons mt-1 text-right"
      };

const TypeIcons = {
  info: 'info-circle',
  warning: 'error',
  danger: 'error-alt',
  success: 'check-circle'
};

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  Row_tag({
      class: "m-0 w-100 d-flex justify-content-center",
      renderBody: function(out) {
        if (input.actions) {
          out.e("div", marko_attrs1, "2", component, 0, 0, {
              onclick: __component.d("click", "onDismiss", false)
            });
        }

        WSAdapt_tag({
            ns: ("col-md-" + (input.ns || "3")) + " col-10",
            qs: ("col-md-" + (input.qs || "4")) + " col-10",
            hs: ("col-md-" + (input.hs || "6")) + " col-10",
            fs: ("col-md-" + (input.fs || "3")) + " col-10",
            class: "animated bounceIn fast",
            renderBody: function(out) {
              out.be("div", marko_attrs2, "4", component);

              out.be("div", marko_attrs3, "5", component);

              out.be("div", marko_attrs4, "6", component);

              out.be("div", marko_attrs5, "7", component, null, 0, {
                  onclick: __component.d("click", "onDismiss", false)
                });

              Bx_tag({
                  type: "x",
                  class: "font-large-1"
                }, out, __component, "8");

              out.ee();

              Row_tag({
                  class: "mt-2",
                  col: [
                      {
                          class: "col-3 text-center",
                          renderBody: function(out) {
                            Bx_tag({
                                type: (input.type && TypeIcons[input.type]) || "info-circle",
                                class: "text-muted font-large-3"
                              }, out, __component, "11");
                          }
                        },
                      {
                          renderBody: function(out) {
                            if (input.status) {
                              out.be("h6", marko_attrs6, "13", component);

                              Locale_tag({
                                  text: input.status
                                }, out, __component, "14");

                              out.ee();
                            }

                            out.be("p", null, "15", component);

                            Locale_tag({
                                text: input.message || "Dialog message is required"
                              }, out, __component, "16");

                            out.ee();

                            if (input.actions) {
                              if (input.actions.passive) {
                                out.be("strong", marko_attrs7, "17", component, null, 0, {
                                    onclick: __component.d("click", "onPassive", false, [
                                        input.actions.passive
                                      ])
                                  });

                                Locale_tag({
                                    text: input.actions.passive.label
                                  }, out, __component, "18");

                                out.ee();
                              } else {
                                out.be("div", marko_attrs8, "19", component);

                                out.be("button", {
                                    "class": marko_classValue(("btn btn-" + (input.actions.no && input.actions.no.active ? "primary" : "light")) + " m-25")
                                  }, "20", component, null, 1, {
                                    onclick: __component.d("click", "onNo", false)
                                  });

                                Locale_tag({
                                    text: (input.actions.no && input.actions.no.label) || "No"
                                  }, out, __component, "21");

                                out.ee();

                                out.be("button", {
                                    "class": marko_classValue(("btn btn-" + ((!input.actions.no) || (!input.actions.no.active) ? "primary" : "light")) + " m-25")
                                  }, "22", component, null, 1, {
                                    onclick: __component.d("click", "onYes", false)
                                  });

                                Locale_tag({
                                    text: (input.actions.yes && input.actions.yes.label) || "Yes"
                                  }, out, __component, "23");

                                out.ee();

                                out.ee();
                              }
                            }
                          }
                        }
                    ]
                }, out, __component, "9");

              out.ee();

              out.ee();

              out.ee();
            }
          }, out, __component, "3");
      }
    }, out, __component, "1");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
